import { Directive, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[appFormatoAltura]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormatoAlturaDirective),
            multi: true
        }
    ]
})
export class FormatoAlturaDirective implements ControlValueAccessor {

    private readonly enterosPermitidos: number = 1;

    private onChange: (value: number | null) => void = () => { };
    private onTouched: () => void = () => { };

    constructor(private el: ElementRef<HTMLInputElement>) { }

    writeValue(value: any): void {
        if (value !== null && value !== undefined && value !== '') {
            const stringValue = value.toString().replace('.', ',');
            this.formatAndSetValues(stringValue, false);
        } else {
            this.el.nativeElement.value = '';
        }
    }

    registerOnChange(fn: any): void { this.onChange = fn; }
    registerOnTouched(fn: any): void { this.onTouched = fn; }
    setDisabledState(isDisabled: boolean): void { this.el.nativeElement.disabled = isDisabled; }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        this.formatAndSetValues(value, true);
    }

    @HostListener('blur')
    onBlur() {
        this.onTouched();
        this.autoCompletarDecimales();
    }

    private autoCompletarDecimales() {
        let valorActual = this.el.nativeElement.value;

        if (!valorActual) return;

        let [enteros, decimales] = valorActual.split(',');

        if (decimales === undefined || decimales === '') {
            decimales = '00';
        } else {
            decimales = decimales.padEnd(2, '0');
        }

        const viewValueFinal = `${enteros},${decimales}`;
        this.el.nativeElement.value = viewValueFinal;

        const modelValue = parseFloat(viewValueFinal.replace(',', '.'));
        this.onChange(modelValue);
    }

    private formatAndSetValues(value: string, emitChangeToModel: boolean) {
        let valorLimpio = value.replace(/[^0-9,]/g, '');

        const partes = valorLimpio.split(',');
        if (partes.length > 2) {
            valorLimpio = partes[0] + ',' + partes[1];
        }

        let [enteros, decimales] = valorLimpio.split(',');

        if (enteros && enteros.length > this.enterosPermitidos) {
            if (decimales === undefined) {
                decimales = enteros.substring(this.enterosPermitidos);
                enteros = enteros.substring(0, this.enterosPermitidos);
            } else {
                enteros = enteros.substring(0, this.enterosPermitidos);
            }
        }

        if (decimales && decimales.length > 2) {
            decimales = decimales.substring(0, 2);
        }

        let viewValue = enteros || '';
        if (decimales !== undefined) {
            viewValue += ',' + decimales;
        }

        this.el.nativeElement.value = viewValue;

        if (emitChangeToModel) {
            let modelValue: number | null = null;
            if (viewValue) {
                if (viewValue === ',') {
                    modelValue = null;
                } else {
                    modelValue = parseFloat(viewValue.replace(',', '.'));
                }
            }
            this.onChange(modelValue);
        }
    }
}
